import { stringify } from "query-string"

import { dhFoodsMain } from "./api"

const endpoint = "/wallet"

export const getContractOwnersWallets = async (queries) => {
  const query =
    stringify(
      queries,
      {
        skipEmptyString: true,
        skipNull: true
      }
    )

  const response =
    await dhFoodsMain.get(`${endpoint}/contract-owner/list?${query}`)

  return response.data
}

export const getContractOwnersWallet = async (contractId) => {
  const response =
    await dhFoodsMain.get(`${endpoint}/contract-owner/${contractId}`)

  return response.data
}